import router from "../../router";
const url = "/Pagos/calculadora";
const initialState = () => ({
  loader: false,
  fechas: {
    inicio: undefined,
    fin: undefined
  },
  cortes: undefined,
  lotes: undefined
});
export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    SET_INITIAL_STATE(state) {
      const newState = initialState();
      Object.keys(newState).forEach(key => {
        state[key] = newState[key];
      });
    },
    SET_LOADER(state, payload) {
      state.loader = payload;
    },
    setFechas(state, payload) {
      state.fechas = payload;
    },
    setCortes(state, payload) {
      state.cortes = payload;
    },
    setLotes(state, payload) {
      state.lotes = payload;
    },
    setComisionistas(state, payload) {
      state.comisionistas = payload;
    }
  },
  actions: {
    async buscar({ commit, dispatch, state }) {
      commit("SET_LOADER", true);
      commit("setCortes", []);
      commit("setLotes", []);
      await window.axios
        .get(url, {
          params: {
            inicio: state.fechas.inicio,
            fin: state.fechas.fin
          }
        })
        .then(resp => {
          commit("setFechas", resp.data.fechas);
          commit("setCortes", resp.data.cortes);
          commit("setLotes", resp.data.lotes);
          commit("setComisionistas", resp.data.comisionistas);
        })
        .catch(e => dispatch("errores", e, { root: true }))
        .finally(() => commit("SET_LOADER", false));
    }
  }
};
